import React, { useState } from 'react';

/**
 * Akciós sáv a főoldal tetején.
 *
 * A `endsAt` lejárta után magától eltűnik — nem kell külön deploy az akció
 * végén. A dátum a Whop promo kód lejáratával egyezzen (CEST, +02:00).
 * Kikapcsolni: `enabled: false`.
 */
const PROMO = {
  enabled: true,
  code: 'SUMMER',
  price: '€18',
  originalPrice: '€27',
  endsAt: '2026-09-01T00:00:00+02:00',
};

function daysLeft(endsAt) {
  const ms = new Date(endsAt).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / 86400000));
}

export default function PromoBanner() {
  const [copied, setCopied] = useState(false);

  if (!PROMO.enabled) return null;
  if (Date.now() >= new Date(PROMO.endsAt).getTime()) return null;

  const left = daysLeft(PROMO.endsAt);

  const copy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(PROMO.code);
    } else {
      const el = document.createElement('textarea');
      el.value = PROMO.code;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative overflow-hidden border-b border-brand-400/15
                    bg-gradient-to-r from-brand-950 via-brand-900/50 to-brand-950">
      {/* Halk fénypászma, ami átsuhan a sávon */}
      <span
        className="absolute inset-0 animate-shimmer pointer-events-none"
        style={{
          background:
            'linear-gradient(90deg, transparent 35%, rgba(201,161,236,0.12) 50%, transparent 65%)',
          animationDuration: '5s',
        }}
      />

      <div className="relative max-w-5xl mx-auto px-4 py-2.5 flex flex-wrap items-center
                      justify-center gap-x-3 gap-y-2 text-center">

        <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase
                         tracking-[0.14em] px-2.5 py-1 rounded-full
                         bg-brand-gradient text-white border border-brand-300/25 shadow-glow-sm">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
               strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3">
            <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />
          </svg>
          Summer Sale
        </span>

        <span className="text-sm text-gray-300">
          <span className="text-gray-600 line-through">{PROMO.originalPrice}</span>
          <span className="text-white font-semibold mx-1.5">{PROMO.price}</span>
          <span className="text-gray-500">with code</span>
        </span>

        <button
          onClick={copy}
          title="Copy code"
          className="group inline-flex items-center gap-1.5 font-mono text-sm font-semibold
                     text-brand-200 bg-black/35 border border-brand-400/25 rounded-lg px-2.5 py-1
                     hover:border-brand-400/60 hover:text-white transition-all duration-200 ease-smooth"
        >
          {PROMO.code}
          {copied ? (
            <svg className="w-3.5 h-3.5 text-emerald-400" fill="none" stroke="currentColor" strokeWidth="2.5"
                 strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          ) : (
            <svg className="w-3.5 h-3.5 opacity-50 group-hover:opacity-90 transition-opacity"
                 fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <rect x="9" y="9" width="13" height="13" rx="2" />
              <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
            </svg>
          )}
        </button>

        <span className="text-xs text-gray-500">
          {left === 1 ? 'Last day' : `${left} days left`}
          <span className="mx-1.5 text-gray-700">·</span>
          card payments only
        </span>
      </div>
    </div>
  );
}
